// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"DropdownMenu_dropdownMenu__36Ezr","dropdownMenu__list":"DropdownMenu_dropdownMenu__list__25LGz"};